import PropTypes from 'prop-types'

export default {
  store: PropTypes.object,
  children: PropTypes.element,
  featureFlags: PropTypes.object,
  user: PropTypes.shape({
    first_name: PropTypes.string,
    last_name: PropTypes.string,
    email_address: PropTypes.string,
    user_id: PropTypes.number,
    logged_in: PropTypes.bool,
  }),
  baseProgressType: PropTypes.shape({
    loading: PropTypes.bool,
    errors: PropTypes.object,
  }),
  params: PropTypes.shape({
    product_type: PropTypes.string,
    state: PropTypes.string,
  }),
}
